import { render, staticRenderFns } from "./EquipoExport.vue?vue&type=template&id=6c6207c0"
import script from "./EquipoExport.vue?vue&type=script&lang=js"
export * from "./EquipoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports